module.exports = "/build/images/address_book.png?562e18c56de89be48164639140a1695c";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/address_book.png
// module id = 4504
// module chunks = 0